import { useRoutes } from "react-router-dom";

import routesObject from "./routes";
import RoutesWrapper from "app/components/RoutesWrapper";

export default function Routes() {
  const routes = useRoutes(routesObject);

  return <RoutesWrapper>{routes}</RoutesWrapper>;
}
